// store/sagas/instantServicesListSaga.js
import { call, put, takeLatest } from "redux-saga/effects";
import {
  fetchServicesRequest,
  fetchServicesSuccess,
  fetchServicesFailure,
} from "../slices/instantServicesListSlice";

const API_BASE_URL = `${process.env.REACT_APP_API_URL}/v1/instant-services`;

const fetchServicesAPI = async (search) => {
  const url = search
    ? `${API_BASE_URL}?search=${encodeURIComponent(search)}`
    : API_BASE_URL;

  const response = await fetch(url);
  const result = await response.json();

  if (!result.success) {
    throw new Error(result.message || "Failed to fetch services");
  }

  return result.data.data;
};

function* fetchServicesSaga(action) {
  try {
    const { search } = action.payload;
    const services = yield call(fetchServicesAPI, search);
    yield put(fetchServicesSuccess(services));
  } catch (error) {
    yield put(
      fetchServicesFailure(
        error.message || "An error occurred while fetching data.",
      ),
    );
  }
}

export function* watchFetchServices() {
  yield takeLatest(fetchServicesRequest.type, fetchServicesSaga);
}
